<template>
  <div>
    <span class="inline-flex text-white">
      <button @click="$router.push('/')" type="button" class="inline-flex items-center px-3 py-2 focus:outline-none">
        <svg
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          class="w-6 h-6"
        >
          <path d="M15 19l-7-7 7-7"></path>
        </svg>
        <span class="text-base font-bold">Mis credenciales</span>
      </button>
    </span>

    <div v-if="loading" class="mt-1/4">
      <div class="w-40 h-40 mx-auto ease-linear border-8 rounded-full loader"></div>

      <div class="w-full mt-6 text-xl font-semibold tracking-widest text-center uppercase text-blue-brand-600">
        Validando credencial...
      </div>
    </div>
    <div v-else>
      <InvalidCredentialAlert v-if="!estadoCredencial" class="mt-4" />

      <div v-else>
        <div class="container max-w-md mx-auto">
          <CachedCredentialAlert class="mt-4" v-if="isCached" />
          <CredentialCard class="mt-4" v-if="credencial" :credencial="credencial" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mixins } from '@colescba/componentes-web'

import credentialProps from '@/mixins/credentialProps'
import * as auth from '@/auth'

const { emitUpdateUser } = auth

import CredentialCard from '@/components/CredentialCard'
import InvalidCredentialAlert from '@/components/InvalidCredentialAlert'
import CachedCredentialAlert from '@/components/CachedCredentialAlert'

/* eslint-disable no-console */

export default {
  props: {
    numero: { type: String, required: true },
  },

  components: { CredentialCard, InvalidCredentialAlert, CachedCredentialAlert },

  mixins: [mixins.SendsToasts, credentialProps],

  data() {
    return {
      isCached: true,
      loading: true,
    }
  },

  async mounted() {
    this.loading = true

    try {
      const response = await this.$http.get(`/credenciales/estado/${this.nroCredencial}`)
      this.credencial.estado = response.data.estado
      this.credencial.fechaValidacion = moment().format('DD-MM-Y HH:mm')
      this.isCached = false
      emitUpdateUser({ user: this.user })
    } finally {
      this.loading = false
    }
  },

  computed: {
    credenciales() {
      return this.user.credenciales
    },

    user() {
      return this.$attrs.user
    },

    credencial() {
      return this.credenciales.find(each => each.numero === this.numero)
    },

    estadoCredencial() {
      return this.credencial.estado || false
    },
  },
}
</script>
